module.exports = __webpack_public_path__ + "static/media/AnelVillegasCH.3e56333a.png";